import React from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import Container from 'components/layout/Container'

const StyledHero = styled.div`
  background-color: #703c2c;
  background-image: url('/images/ben/herobg_sep20.jpg');
  background-position: 40% 15%;
  background-repeat: repeat;
  padding-bottom: 60px;
  padding-top: 60px;
`

const StyledContainer = styled(Container)`
  display: block;
  text-align: center;


  & img {
    display: inline-block;
    margin: 5px;

    ${({ theme }) => theme.mediaQueries.sm} {
      margin: 5px 10px 5px 0;
    }
  }
`

const Title = styled.div`
  margin-bottom: 16px;
`

const Blurb = styled(Text)`
  color: #ffffff;
  font-size: 1.1em;
  font-weight: normal;
  font-family: Verdana, sans-serif;
`

const Hero = () => {
  const TranslateString = useI18n();
  return (
    <StyledHero>
      <StyledContainer>
        <Title>
          <img src="/images/SEP-20.png" alt="SEP-20" width="134" height="35" style={{width:134,height:35}}/>
          <img src="/images/FACTORY.png" alt="FACTORY" width="173" height="35" style={{width:173,height:35}}/>
        </Title>
        <Blurb>
         {TranslateString(405,'Customize your tokens.')}
        </Blurb>
      </StyledContainer>
    </StyledHero>
  )
}

export default Hero
